module.exports = __webpack_public_path__ + "static/img/kpicon-eye-on-disable.d294eb97.svg";